export const isSeatAvailable = (availableSeatCount?: number | null, seatLimit?: number) => {
  if (!seatLimit) {
    return true;
  }

  if (availableSeatCount === undefined || availableSeatCount === null) {
    return false;
  }

  return availableSeatCount > 0;
};
